import React from 'react';
import {
  DialogContainer,
  DialogHeader,
  DialogTitle,
  DialogText,
  DialogFooter,
} from '../shared';

interface InterviewCompletedDialogProps {
  open: boolean;
}

const CompletedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g clipPath="url(#clip0_343_1096)">
      <path d="M11.7303 30.9011C10.3197 29.9134 10.6705 27.2537 9.80036 25.8858C8.89822 24.4738 6.35719 23.6451 6.0699 22.0158C5.78262 20.3865 7.88698 18.7387 8.25177 17.1033C8.60184 15.5216 7.36226 13.141 8.34997 11.7304C9.33767 10.3198 11.9987 10.6704 13.3653 9.80048C14.7838 8.89719 15.606 6.35731 17.2353 6.07002C18.8646 5.78274 20.5124 7.8871 22.1478 8.25189C23.7308 8.60173 26.1101 7.36238 27.5207 8.35009C28.9313 9.33779 28.5805 11.9975 29.4506 13.3654C30.3539 14.7839 32.8938 15.6061 33.1811 17.2354C33.4684 18.8647 31.364 20.5125 30.9992 22.1479C30.6494 23.7309 31.8887 26.1102 30.901 27.5208C29.9133 28.9314 27.2536 28.5806 25.8857 29.4507C24.4737 30.3529 23.645 32.8939 22.0157 33.1812C20.3864 33.4685 18.7386 31.3641 17.1032 30.9993C15.5215 30.6493 13.1409 31.8888 11.7303 30.9011Z" fill="#171C27" stroke="#171C27" strokeWidth="2.11765" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.5948 21.5877L18.2746 24.1643L24.2868 15.5781" stroke="white" strokeWidth="2.11765" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_343_1096">
        <rect width="33.8824" height="33.8824" fill="white" transform="translate(0 5.88361) rotate(-10)"/>
      </clipPath>
    </defs>
  </svg>
);

const InterviewCompletedDialog: React.FC<InterviewCompletedDialogProps> = ({
  open,
}) => {
  return (
    <DialogContainer open={open}>
      <DialogHeader variant="interview" icon={<CompletedIcon />} />

      <div style={{ padding: '24px', textAlign: 'center', borderTop: '1px solid #171C27' }}>
        <DialogTitle color="#171C27" size="lg" centered>
          Interview Completed
        </DialogTitle>
        <DialogText centered style={{ marginBottom: 0 }}>
          Your interview responses have been submitted successfully for evaluation.
        </DialogText>
      </div>

      <DialogFooter />
    </DialogContainer>
  );
};

export default InterviewCompletedDialog;
